import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import { Card, CardText } from 'material-ui/Card';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import { FormattedMessage } from 'react-intl';
import { CSVLink } from "react-csv";
import { convertToCsv } from './convertToCsv';
import { checkMobile, isIpadOS } from "../../lib";

const CSVDownloadButton = ({ disabled }) => {
  return (
    <FlatButton
      label={<FormattedMessage id="transcriptions.csvDownload" />}
      disabled={disabled}
      backgroundColor="#60d1bd"
      hoverColor="#60d1bd"
      style={{
        boxShadow: "none",
        height: "40px",
        lineHeight: "40px",
        minWidth: "160px",
        borderRadius: "5px",
      }}
      labelStyle={{
        color: "#fff",
      }}
    />
  );
};

class TranscriptionInfo extends Component {
  state = {
    recording: {},
    searchText: '',
    csvData: []
  };
  loadingCSV = false;

  componentDidMount() {
    this.props.location.state.transcription ? this.setState({ recording: this.props.location.state.transcription }) : this.props.history.goBack();
    this.setState({ searchText: this.props.location.state.searchText });
  }

  convertToCsv = (data) => {
    if(this.props.location.state && this.props.location.state.transcription) {
      this.loadingCSV = true;
      let csvData = convertToCsv(this.props.location.state.transcription, data);
      if(this.state.csvData.length === 0) {
        this.setState({ csvData });
      }
    } else {
      this.props.history.goBack();
    }
  }

  getHighlightedText(text) {
    if (this.state.searchText) {
      const highlight = this.state.searchText
      // Split on highlight term and include term into parts, ignore case
      const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
      return <span> { parts.map((part, i) => 
          <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold', backgroundColor: '#ffff00' } : {} }>
              { part }
          </span>)
      } </span>;
    }
    return text;
  }

  getRecordingOffset = (words, type) => {
    if(words.length > 0) {
      return parseInt(words[0]['startTime']['seconds']) 
    } else {
      return 0
    }
  }

  formatGoogleTranscription = (data, recording) => {
    data = data.map(d => {
      return {
        startOffset: parseInt(d.alternatives[0].words[0].startTime.seconds || d.alternatives[0].words[1].startTime.seconds),
        timestamp: moment(new Date(recording.recording_started_at * 1000)).add('seconds', this.getRecordingOffset(d.alternatives[0].words, 'start')).toDate(),
        transcript: d.alternatives[0].transcript
      }
    });
    return data;
  }
  
  getCSVFileName  = () => {
    if(this.props.location.state && this.props.location.state.transcription) {
      const date = moment.unix(this.props.location.state.transcription.recording_started_at);
      return `${this.props.location.state.transcription.channel_id.split('.')[1]}_${date.format('YYYYMMDDHHmm')}`
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    let transcription = [];
    if (this.state.recording.video_transcription) {
      let t = JSON.parse(this.state.recording.video_transcription);
      if(Array.isArray(t)) {
        transcription = t;
      }
      
    }

    let googleTranscription = [];
    if (this.props.location.state && this.props.location.state.transcription.google_stt) {
      if(Array.isArray(JSON.parse(this.props.location.state.transcription.google_stt))) {
        googleTranscription = JSON.parse(this.props.location.state.transcription.google_stt)
      } else {
        let t = JSON.parse(this.props.location.state.transcription.google_stt).results;
      if(Array.isArray(t)) {
        googleTranscription = this.formatGoogleTranscription(t, this.props.location.state.transcription);
      }
      }
      
    } else {
      this.props.history.goBack();
    }

    if(googleTranscription.length > 0 && !this.loadingCSV) {
      this.convertToCsv(googleTranscription);
    }

    return (
      <Paper
        style={{
          padding: '30px',
          borderRadius: '5px',
          border: '1px solid #cecece',
          boxShadow: 'none',
          marginBottom: '16px',
        }}
      >
        <div
          style={{
            fontSize: '16px',
            marginBottom: '16px',
          }}
        >
          <div>
            <FlatButton
              onClick={() => this.props.history.goBack()}
              icon={<NavigationArrowBack color="#3659A0" style={{ marginLeft: 0 }} />}
              label={<FormattedMessage id="transcriptions.back" />}
              labelStyle={{
                color: '#3659A0',
              }}
              style={{
                marginBottom: '5px',
              }}
            />
          </div>
          {console.log("..........",isIpadOS(), checkMobile())}
          {!checkMobile() && !isIpadOS() && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {this.state.recording.filename}
            {googleTranscription.length === 0 ? <CSVDownloadButton disabled={true} /> :
            <CSVLink data={this.state.csvData} filename={this.getCSVFileName()} >
              <CSVDownloadButton disabled={false} />
            </CSVLink>}
          </div> }
        </div>
        <Card style={{ marginBottom: '10px', border: '1px solid #c2c2c2', boxShadow: 'none' }}>
          <CardText>
            
            {googleTranscription && googleTranscription.map(result => {
              return (
                <div key={result.timestamp} style={{ marginBottom: '10px', lineHeight: '20px' }}>
                 <a
                    target="_blank"
                    href={this.state.recording ? this.state.recording.s3_url + `#t=${result.startOffset}` : ''}
                    style={{ fontWeight: 'bold', marginRight: '6px' }}
                  >
                    {moment(result.timestamp).format('YYYY-MM-DD HH:mm:ss')}:
                  </a>
                  <span>{this.getHighlightedText(result.transcript)}</span>
                </div>
              );
            })}
            {googleTranscription.length === 0 && <h4><FormattedMessage id="transcriptions.noTranscriptions" /></h4>}
          </CardText>
        </Card>
      </Paper>
    );
  }
}

export default TranscriptionInfo;



// WEBPACK FOOTER //
// src/routes/Transcriptions/TranscriptionInfo.js